import { render, staticRenderFns } from "./programmeManagement.vue?vue&type=template&id=62e97a34&scoped=true&"
import script from "./programmeManagement.vue?vue&type=script&lang=js&"
export * from "./programmeManagement.vue?vue&type=script&lang=js&"
import style0 from "./programmeManagement.vue?vue&type=style&index=0&id=62e97a34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e97a34",
  null
  
)

export default component.exports